module.exports = __webpack_public_path__ + "img/banner2.f0168a9c.jpg";